class ReportService extends BaseService
	@registerService()
	@inject 'BaseRepository', 'ReportRepository', 'QueueTaskRepository', 'BACKEND_QUEUE_TASK_TYPE'

	getShopsSalesAmounts: (startTime, endTime, isVatIncluded, shopId = null) ->
		query = @ReportRepository.createQuery()
		query.addParameter('start_time', startTime)
		query.addParameter('end_time', endTime)
		query.addParameter('is_vat_included', isVatIncluded)
		query.addParameter('shop_id', shopId)

		return @ReportRepository.fetch('/shops_sales', query).then (response) -> response.data

	getOrdersAnalytics: (
		startTime,
		endTime,
		currency,
		isVatIncluded = null,
		shouldIncludeCustomers = null,
		groupIntervalSize = null,
		shopId = null,
		reports = []
	) ->
		query = @ReportRepository.createQuery()
		query.addParameter('start_time', startTime)
		query.addParameter('end_time', endTime)
		query.addParameter('currency', currency)
		query.addParameter('is_vat_included', isVatIncluded)
		query.addParameter('should_include_customers', shouldIncludeCustomers)
		query.addParameter('group_interval_size', groupIntervalSize)
		query.addParameter('shop_id', shopId)
		query.addParameter('reports', reports)

		return @ReportRepository.fetch('/orders_analytics', query).then (response) -> response.data

	validate: (type, version = null) ->
		@ReportRepository
			.findByQuery null, "/pre-validate/#{type}/#{version}"
			.then (response) ->
				return response.data

	search: (filter, withCounts = false) ->
		filter.page ?= 1
		filter.page_size ?= @QueueTaskRepository.pageSize

		query = @QueueTaskRepository.createQuery()
		query.sortBy 'id', 'DESC'
		query.setPagination (filter.page - 1) * filter.page_size, filter.page_size
		query.with 'report', 'report>files'
		query.criteria 'type', '=', @BACKEND_QUEUE_TASK_TYPE.REPORT_CREATE
		query.criteria 'status', '=', filter.status if filter.status?
		query.criteria 'report.type', '=', filter.report_type if filter.report_type?
		query.criteria 'report.from', '>=', filter.from if filter.from?
		query.criteria 'report.to', '<=', filter.to if filter.to?
		query.criteria 'report.create_time', '>=', filter.from_create_time if filter.from_create_time?
		query.criteria 'report.create_time', '<=', filter.to_create_time if filter.to_create_time?

		if withCounts
			@QueueTaskRepository
				.getEntitiesWithCount query
				.then (response) =>
					filter.count = response.count

					return @parseReports(response.data)
		else
			@QueueTaskRepository
				.getEntities query
				.then (reports) =>
					return @parseReports(reports)

	parseReports: (reports) ->
		for report in reports
			report.status = if _.isEmpty(report.status) then 'failed' else report.status
			report.report.data = JSON.parse(report.report.data) if report.report?.data?

			if report.report?.files
				for file in report.report.files
					file.name = file.path.split('/').pop()

		return reports

	download: (file) ->
		@ReportRepository.download(file.id)
